import $ from "jquery"

function showPwError($field, message) {
  $field.addClass('is-invalid');
  var $existing = $field.next('.profile-field-error');
  if ($existing.length) {
    $existing.text(message);
  } else {
    $('<div class="profile-field-error text-danger small mt-1"></div>')
      .text(message)
      .insertAfter($field);
  }
}

function clearPwError($field) {
  $field.removeClass('is-invalid');
  $field.next('.profile-field-error').remove();
}

window.initPasswordValidation = function() {
  var $password = $('#user_password');
  var $confirmation = $('#user_password_confirmation');

  // Toggle password visibility
  $(document)
    .off('click.pwToggle', '.toggle-password')
    .on('click.pwToggle', '.toggle-password', function() {
      var $input = $($(this).find('i').data('target'));
      var $icon = $(this).find('i');

      if ($input.attr('type') === 'password') {
        $input.attr('type', 'text');
        $icon.removeClass('fa-eye-slash').addClass('fa-eye');
      } else {
        $input.attr('type', 'password');
        $icon.removeClass('fa-eye').addClass('fa-eye-slash');
      }
    });

  // Clear errors on input
  $password.off('input.pwValidate').on('input.pwValidate', function() {
    if ($(this).val()) clearPwError($(this));
  });
  $confirmation.off('input.pwValidate').on('input.pwValidate', function() {
    if ($(this).val()) clearPwError($(this));
  });

  // Submit validation
  $(document)
    .off('submit.passwordValidate', '.profile-form')
    .on('submit.passwordValidate', '.profile-form', function(event) {
      var newPass = $password.val();
      var confirmPass = $confirmation.val();
      var hasError = false;

      if (newPass && !/(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(newPass)) {
        showPwError($password, 'Password must include at least 8 characters with both uppercase and lowercase letters.');
        hasError = true;
      }

      if (confirmPass && newPass !== confirmPass) {
        showPwError($confirmation, 'Password confirmation does not match.');
        hasError = true;
      }

      if (hasError) {
        event.preventDefault();
        return false;
      }
    });
};

window.initAccountValidation = function() {
  if (window.initFieldToggles) window.initFieldToggles();
};

$(document).on('turbolinks:load', function() {
  if ($('#user_password').length) {
    window.initPasswordValidation();
  }
  if ($('#user_first_name').length && !$('#user_password').length) {
    window.initAccountValidation();
  }
});
